import UploadPreview from "./UploadPreview";
export { PREVIEW_TYPES } from "./consts";
export default UploadPreview;
export { UploadPreview };